
import { Article, CostParams, CostBreakdown } from '../types.ts';

export const calculateCostBreakdown = (article: Article, params: CostParams): CostBreakdown => {
  // 1. Yarn Cost
  const totalYarnWeightGpm = article.details.warpWeightGpm + article.details.weftWeightGpm;
  const elastaneWeightGpm = totalYarnWeightGpm * (article.details.elastanePercentage / 100);
  const cottonWeightGpm = totalYarnWeightGpm - elastaneWeightGpm;

  const cottonMaterialCost = (cottonWeightGpm / 1000) * params.cottonCostPerKg;
  const spinningCost = (cottonWeightGpm / 1000) * params.spinningCostPerKg;
  const elastomerCost = (elastaneWeightGpm / 1000) * params.elastomerCostPerKg;
  const totalYarnCost = cottonMaterialCost + spinningCost + elastomerCost;

  // 2. Weaving Cost & Waste
  const weavingCost = params.weavingCostPerMeter;
  const costAfterWeaving = totalYarnCost + weavingCost;
  const weavingWasteAmount = costAfterWeaving * (params.weavingWaste / 100);
  const costAfterWeavingWaste = costAfterWeaving + weavingWasteAmount;

  // 3. Finishing Cost & Waste
  const finishingCost = article.finishingCostPerMeter;
  const costAfterFinishing = costAfterWeavingWaste + finishingCost;
  const finishingWasteAmount = costAfterFinishing * (params.finishingWaste / 100);
  const costAfterFinishingWaste = costAfterFinishing + finishingWasteAmount;

  // 4. General Expenses & Final Cost
  const subtotal = costAfterFinishingWaste;
  const generalExpensesAmount = params.includeGeneralExpenses ? subtotal * (params.generalExpensesPercentage / 100) : 0;
  const finalCost = subtotal + generalExpensesAmount;

  return {
    articleName: article.name,
    cottonMaterialCost,
    spinningCost,
    elastomerCost,
    totalYarnCost,
    weavingCost,
    costAfterWeaving,
    weavingWasteAmount,
    costAfterWeavingWaste,
    finishingCost,
    costAfterFinishing,
    finishingWasteAmount,
    costAfterFinishingWaste,
    subtotal,
    generalExpensesAmount,
    finalCost,
  };
};
